import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c4567002&lang=html"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c4567002&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4567002')) {
      api.createRecord('c4567002', component.options)
    } else {
      api.reload('c4567002', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c4567002&lang=html", function () {
      api.rerender('c4567002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueQuillEditorone/div/index.vue"
export default component.exports